import store from '@/store'

/**
 * @param {String} value
 * @returns {Boolean}
 */
export function checkPermission(value) {
  if (value) {
    const roles = store.getters && store.getters.roles

    const hasPermission = roles.indexOf(value) !== -1

    if (!hasPermission) {
      return false
    }
    return true
  } else {
    console.error(`need roles! Like v-permission="11"`)
    return false
  }
}

/**
 * @param {Array} value
 * @example v-permission="12"
 */
export const permissionDirective = {
  inserted(el, binding, vnode) {
    const { value } = binding
    if (checkPermission(value)) {
      el.parentNode && el.parentNode.removeChild(el)
    }
  }
}

/**
 * @param {Array} value
 * @returns {Array}
 */
export function formatRole(value) {
  // value = [{"havePermission":true,"id":28}, {"havePermission":true,"id":29}, {"havePermission":true,"id":30}, {"havePermission":true,"id":31}]
  const roles = []
  if (value && value instanceof Array && value.length > 0) {
    value.forEach(role => {
      roles.push(role.id)
    })
  } else {
    console.error(`nothing role`)
  }
  return roles
}
